export const SET_MY_CONVERSATIONS = 'SET_MY_CONVERSATIONS';
export const CLEAR_MY_CONVERSATIONS = 'CLEAR_MY_CONVERSATIONS';
